import { baseUrl } from "../../shared/baseURL";
import * as ActionTypes from "../Types/ActionTypes";

export const postDashboard = (data) => (dispatch) => {
  dispatch(postDashboardLoadingStart());
  const myheader = new Headers({
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "Bearer " + data.token,
  });

  return fetch(baseUrl + "dashboard-1", {
    method: "POST",
    headers: myheader,
    body: JSON.stringify(data?.body),
  })
    .then((response) => response.json())
    .then((res) => {
      dispatch(postDashboardSucess(res));
    })
    .catch((error) => {
        //addd sweet alert
        dispatch(postDashboardLoadingStop())
    });
};

export const postDashboardLoadingStart = () => ({
  type: ActionTypes.DASHBOARD_LOADER_START,
});

export const postDashboardSucess = (data) => ({
  type: ActionTypes.DASHBOARD,
  payload: data,
});

export const postDashboardLoadingStop = () => ({
  type: ActionTypes.DASHBOARD_LOADER_STOP,
});
